module.exports = __webpack_public_path__ + "img/Bear01.c579ba2c.png";